<template>
  <div>
    <filtroProjetosLote
      :sqLote="sqLote"
      @limparGrid="limparGrid"
      @filtroPrjetosLote="filtrarProjetosLote"
    />

    <gridProjetos
      :importacao="true"
      :items="projetosLote"
      :is-loading="loadingGridLote"
      @projetoAstecFiltrados="onPaginarProjetos"
    />
  </div>
</template>

<script>
import gridProjetos from "@/components/astec/projetos/gridProjetos";
import { LoteImportacaoService } from "@/services/astec/loteImportacao";
import filtroProjetosLote from "@/components/astec/projetos/lotesImportacao/filtroProjetosLote";

export default {
  components: {
    filtroProjetosLote,
    gridProjetos
  },
  data() {
    return {
      projetosLote: {
        data: [],
        total: 0,
        current_page: 1
      },
      sqLote: null,
      filtrosAtuais: {},
      primeiraCarga: true,
      loadingGridLote: false
    };
  },

  created() {
    const sqAstecIntegracaoLote = localStorage.getItem("sqAstecIntegracaoLote");

    if (sqAstecIntegracaoLote) {
      this.sqLote = parseInt(sqAstecIntegracaoLote);

      this.filtrosAtuais = {
        page: 1,
        per_page: 10,
        sq_astec_integracao_lote: this.sqLote
      };
    }
  },

  methods: {
    async filtrarProjetosLote(filtro) {
      if (this.loadingGridLote) {
        return;
      }

      if (this.primeiraCarga && !filtro) {
        return;
      }

      this.primeiraCarga = false;

      this.filtrosAtuais = {
        ...this.filtrosAtuais,
        ...filtro,
        sq_astec_integracao_lote:
          this.filtrosAtuais.sq_astec_integracao_lote || this.sqLote
      };

      this.loadingGridLote = true;

      try {
        const resultado = await LoteImportacaoService.getProjetosLote(
          this.filtrosAtuais
        );

        this.projetosLote = resultado;

        if (this.$refs.accordionFiltroProjetosLote) {
          this.$refs.accordionFiltroProjetosLote.fechar();
        }
        this.$tools.fecharMenu();
      } catch (error) {
        this.limparGrid();
      } finally {
        this.loadingGridLote = false;
      }
    },

    onPaginarProjetos(novosFiltros) {
      this.filtrarProjetosLote({
        ...novosFiltros,
        sq_astec_integracao_lote: this.sqLote
      });
    },

    limparGrid() {
      this.projetosLote = {
        data: [],
        total: 0,
        current_page: 1
      };
    }
  }
};
</script>
